import { Heart } from 'lucide-react';

import { useFavorites } from '@/features/favorites/favorites.context';
import { cn } from '@/lib/cn';

interface FavoriteButtonProps {
  productId: string;
  productName: string;
  className?: string;
}

export function FavoriteButton({ productId, productName, className }: FavoriteButtonProps) {
  const { isFavorite, toggle } = useFavorites();
  const active = isFavorite(productId);

  return (
    <button
      type="button"
      onClick={() => toggle(productId)}
      aria-pressed={active}
      aria-label={
        active ? `Remover ${productName} dos favoritos` : `Salvar ${productName} nos favoritos`
      }
      className={cn(
        'grid size-11 shrink-0 place-items-center rounded-full backdrop-blur-sm transition-all',
        'border border-sand-300 bg-white/85 hover:scale-110 active:scale-95',
        className,
      )}
    >
      <Heart
        className={cn(
          'size-[1.15rem] transition-colors',
          active ? 'fill-orange-500 text-orange-500' : 'text-brown-700',
        )}
        aria-hidden="true"
      />
    </button>
  );
}
